export const getCardToken = (card = {}) => {
    if (typeof window !== 'undefined') {
        return new Promise((resolve, reject) => {
            const options = {
                onSuccess(response) {
                    // Implement success handling here
                    resolve(response);
                },
                onFailure(response) {
                    // Implement error handling here
                    reject(response);
                },
            };

            window.MidtransNew3ds.getCardToken(card, options);
        });
    }

    return false;
};

export default { getCardToken };
